module.exports = __webpack_public_path__ + "img/one3.4c5c6360.png";